import { colors } from "../../tokens";
import { alertColors } from "./definitions";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var InfoIcon = function InfoIcon() {
  return ___EmotionJSX("svg", {
    width: "18",
    height: "18",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("g", {
    fill: "none",
    fillRule: "evenodd"
  }, ___EmotionJSX("circle", {
    fill: alertColors.icon.info,
    fillRule: "nonzero",
    cx: "9",
    cy: "9",
    r: "9"
  }), ___EmotionJSX("g", {
    strokeLinejoin: "round",
    stroke: "#FFF",
    strokeWidth: "1.4"
  }, ___EmotionJSX("path", {
    strokeLinecap: "round",
    d: "M7 13.4h4M7.7 8H9v5.4"
  }), ___EmotionJSX("path", {
    d: "M8.5 4c-.3 0-.5.2-.5.4 0 .3.2.5.5.5.2 0 .5-.2.5-.5 0-.2-.3-.4-.5-.4h0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
export var SuccessIcon = function SuccessIcon() {
  return ___EmotionJSX("svg", {
    width: "18",
    height: "18",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("g", {
    fill: "none",
    fillRule: "evenodd"
  }, ___EmotionJSX("circle", {
    fill: alertColors.icon.success,
    cx: "9",
    cy: "9",
    r: "9"
  }), ___EmotionJSX("path", {
    d: "M12 6a1 1 0 00-.8.5L8 9.5 6.7 8.4A1 1 0 005 9c0 .3.1.5.3.7l2 2c.2.2.4.3.7.3.7 0 .8-.4.8-.4l4-4s.2-.2.2-.6c0-.6-.4-1-1-1z",
    fill: "#FFF"
  })));
};
export var CriticalIcon = function CriticalIcon() {
  return ___EmotionJSX("svg", {
    width: "18",
    height: "18",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("g", {
    fill: "none",
    fillRule: "evenodd"
  }, ___EmotionJSX("circle", {
    fill: alertColors.icon.critical,
    cx: "9",
    cy: "9",
    r: "9"
  }), ___EmotionJSX("g", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }, ___EmotionJSX("path", {
    d: "M14 9A5 5 0 114 9a5 5 0 0110 0h0zM5.5 12.5l7-7"
  }))));
};
export var WarningIcon = function WarningIcon() {
  return ___EmotionJSX("svg", {
    width: "18",
    height: "18",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("g", {
    fill: "none",
    fillRule: "evenodd"
  }, ___EmotionJSX("path", {
    d: "M12 4a1 1 0 00-.8.5L8 7.5 6.7 6.4A1 1 0 005 7c0 .3.1.5.3.7l2 2c.2.2.4.3.7.3.7 0 .8-.4.8-.4l4-4s.2-.2.2-.6c0-.6-.4-1-1-1z",
    fill: "#FFF"
  }), ___EmotionJSX("circle", {
    fill: alertColors.icon.warning,
    cx: "9",
    cy: "9",
    r: "9"
  }), ___EmotionJSX("g", {
    stroke: "#FFF",
    strokeLinejoin: "round"
  }, ___EmotionJSX("path", {
    strokeWidth: "1.5",
    strokeLinecap: "round",
    d: "M9 4v5"
  }), ___EmotionJSX("path", {
    d: "M9 12a1 1 0 100 2 1 1 0 000-2h0z",
    strokeWidth: ".7",
    fill: "#FFF"
  }))));
};
export var AlertIcon = function AlertIcon(_ref) {
  var appearance = _ref.appearance;

  switch (appearance) {
    case "info":
    default:
      return ___EmotionJSX(InfoIcon, null);

    case "critical":
      return ___EmotionJSX(CriticalIcon, null);

    case "warning":
      return ___EmotionJSX(WarningIcon, null);

    case "success":
      return ___EmotionJSX(SuccessIcon, null);
  }
};
export var CrossIcon = function CrossIcon() {
  return ___EmotionJSX("svg", {
    width: "10",
    height: "10",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("path", {
    d: "M1.1 1.1c.2-.1.6-.1.8 0h0L5 4.3 8.1 1h.7c.2.2.2.6 0 .8h0L5.9 5l3 3.1c.2.2.2.5.1.7h0c-.2.2-.6.2-.8 0h0L5 5.9l-3.1 3c-.2.2-.5.2-.7.1h0a.5.5 0 010-.8h0l3-3.1-3-3.1a.5.5 0 01-.1-.7h0z",
    fill: colors.gray.inkHeadings,
    fillRule: "nonzero",
    stroke: colors.gray.inkHeadings
  }));
};